'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var VerificationIconWrapper = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  ", ";\n"])), function (props) {
  return props.background && styled.css(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n    background-color: #000 !important;\n    width: fit-content;\n    padding: 6px 14px 6px 9px;\n    border-radius: 15px;\n}\n    "])));
});
var VerificationStatusIcon$1 = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  font: normal normal normal 12px/16px Roboto;\n  ", ";\n\n  ", ";\n\n  svg {\n    height: ", "px;\n  }\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-700'));
}, function (props) {
  return props.background && props.theme.themeProp('color', props.theme.getColor('gray-100'), props.theme.getColor('gray-100'));
}, function (props) {
  var _props$iconHeight;

  return (_props$iconHeight = props.iconHeight) !== null && _props$iconHeight !== void 0 ? _props$iconHeight : 15;
});
var VerificationStatusColor = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: ", "px;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  ", ";\n"])), function (props) {
  var _props$iconHeight2;

  return ((_props$iconHeight2 = props.iconHeight) !== null && _props$iconHeight2 !== void 0 ? _props$iconHeight2 : 15) * 2 / 3;
}, function (props) {
  var _props$iconHeight3;

  return ((_props$iconHeight3 = props.iconHeight) !== null && _props$iconHeight3 !== void 0 ? _props$iconHeight3 : 15) * 2 / 3;
}, function (props) {
  var _props$iconHeight4;

  return ((_props$iconHeight4 = props.iconHeight) !== null && _props$iconHeight4 !== void 0 ? _props$iconHeight4 : 15) * 2 / 3;
}, function (props) {
  var darkThemeColor = props.theme.getColor('gray-100');
  var lightThemeColor = props.theme.getColor('gray-500');

  if (props.status === 'verified') {
    darkThemeColor = props.theme.getColor('emerald-500');
    lightThemeColor = props.theme.getColor('emerald-500');
  } else if (props.status === 'pending') {
    darkThemeColor = props.theme.getColor('signal-yellow-500');
    lightThemeColor = props.theme.getColor('signal-yellow-500');
  } else if (props.status === 'rejected') {
    darkThemeColor = props.theme.getColor('red-600');
    lightThemeColor = props.theme.getColor('red-600');
  } else if (props.status === 'mixed') {
    darkThemeColor = '#008CDB';
    lightThemeColor = '#008CDB';
  }

  return props.theme.themeProp('background-color', darkThemeColor, lightThemeColor);
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React__namespace.createElement("path", {
  fill: "currentColor",
  d: "M9.3 12.662q-1.698 0-2.864-1.166T5.27 8.632q0-1.697 1.166-2.864T9.3 4.602q1.698 0 2.864 1.166t1.166 2.864q0 1.698-1.166 2.864T9.3 12.662zm0-1.86q.925 0 1.548-.622.622-.622.622-1.548t-.622-1.547q-.623-.623-1.548-.623t-1.548.623q-.622.622-.622 1.547t.622 1.548q.623.622 1.548.622zm0 12.686q-4.023-1.097-6.661-4.735Q0 15.113 0 10.616V3.482L9.3 0l9.3 3.482v7.134q0 4.498-2.639 8.137-2.638 3.639-6.661 4.735zm0-11.744zm0-9.765L1.86 4.757v5.86q0 1.769.507 3.421.507 1.653 1.408 3.083 1.254-.639 2.626-.999 1.373-.36 2.899-.36t2.898.36q1.373.36 2.627 1 .901-1.431 1.408-3.084.507-1.652.507-3.422V4.757L9.3 1.98zm0 15.643q-1.2 0-2.307.26-1.108.26-2.093.73.923 1.025 2.03 1.773 1.109.747 2.37 1.143 1.262-.395 2.363-1.143 1.102-.748 2.025-1.773-.985-.47-2.087-.73-1.102-.26-2.301-.26z"
});

function SvgVerification(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2.5 0 24 24"
  }, props), _ref);
}

var VerificationStatusIcon = React__default['default'].forwardRef(function VerificationStatusIcon(_ref, forwardedRef) {
  var status = _ref.status,
      iconHeight = _ref.iconHeight,
      background = _ref.background,
      props = defaultTheme._objectWithoutProperties(_ref, ["status", "iconHeight", "background"]);

  return React__default['default'].createElement(VerificationIconWrapper, {
    background: background
  }, React__default['default'].createElement(VerificationStatusIcon$1, defaultTheme._extends({
    iconHeight: iconHeight,
    background: background,
    ref: forwardedRef
  }, props), React__default['default'].createElement(SvgVerification, null), React__default['default'].createElement(VerificationStatusColor, {
    iconHeight: iconHeight,
    status: status,
    background: background
  })));
});
VerificationStatusIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  status: defaultTheme.PropTypes.oneOf(['verified', 'pending', 'rejected', 'mixed']).isRequired,
  iconHeight: defaultTheme.PropTypes.number,
  background: defaultTheme.PropTypes.bool
} : {};
VerificationStatusIcon.defaultProps = {
  iconHeight: 15,
  background: false
};

exports.VerificationStatusIcon = VerificationStatusIcon;
